var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrain = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  fill: "none",
  viewBox: "0 0 50 50"
}, props), /*#__PURE__*/React.createElement("mask", {
  width: 50,
  height: 50,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h50v50H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6C6C6C",
  d: "M10.417 31.49V12.5q0-2.039 1.171-3.28 1.173-1.24 3.175-1.898 2.003-.66 4.658-.866T25 6.25q3.037 0 5.683.206 2.646.207 4.631.866 1.986.66 3.127 1.899 1.143 1.24 1.142 3.279v18.99q0 2.512-1.749 4.261-1.748 1.749-4.26 1.749l3.125 3.125v1.042h-1.763L30.769 37.5H19.231l-4.167 4.167H13.3v-1.042l3.125-3.125q-2.513 0-4.26-1.749-1.75-1.749-1.75-4.26M25 8.334q-6.122 0-8.914.812-2.793.81-3.37 2.394h24.616q-.541-1.608-3.34-2.406-2.799-.8-8.992-.8M12.5 22.917h11.458v-9.295H12.5zm13.542 0H37.5v-9.295H26.042zm-8.334 9.615q.995 0 1.659-.665.665-.665.665-1.659 0-.993-.665-1.658-.665-.666-1.659-.666-.993 0-1.659.665-.665.666-.665 1.66t.665 1.658 1.66.665m14.584 0q.993 0 1.658-.665.666-.665.665-1.659 0-.993-.665-1.658-.665-.666-1.659-.666-.993 0-1.658.665-.666.666-.665 1.66 0 .993.665 1.658.665.666 1.659.665m-15.866 2.885h17.148q1.634 0 2.78-1.146t1.146-2.78V25h-25v6.49q0 1.635 1.146 2.78 1.145 1.147 2.78 1.147"
}))));
export default SvgTrain;